/**
 * The languages the PDF report worker can actually print.
 *
 * One list for the three dialogs that offer a report — `GenerateReportDialog`,
 * `RunDeviationAnalysisDialog` and `RunSurfaceDifferenceDialog` — each of which
 * carried its own copy, two of them with a comment admitting it (finding M11).
 * The worker resolves its copy from
 * `server/background/src/functions/processReport/locales/<locale>.json`; a code
 * it has no bundle for falls back to English there, so a list that drifts
 * produces a report in the wrong language rather than an error anyone sees.
 */
export const SUPPORTED_REPORT_LOCALES = ['en', 'de', 'es', 'fr', 'hu'] as const;

export type SupportedReportLocale = (typeof SUPPORTED_REPORT_LOCALES)[number];

/**
 * The reader's own language when the worker can print it, English otherwise.
 * Matched exactly, as the three dialogs always have: a regional tag
 * (`en-GB`) is not one of the worker's bundles.
 */
export function reportLocaleFor(language: string): SupportedReportLocale {
  return (SUPPORTED_REPORT_LOCALES as readonly string[]).includes(language)
    ? (language as SupportedReportLocale)
    : 'en';
}
